import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleChevronUpFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1Zm3.53,9.53c-.146,.146-.338,.22-.53,.22s-.384-.073-.53-.22l-2.47-2.47-2.47,2.47c-.293,.293-.768,.293-1.061,0s-.293-.768,0-1.061l3-3c.293-.293,.768-.293,1.061,0l3,3c.293,.293,.293,.768,0,1.061Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCircleChevronUpFill18.js.map